import { FC, ReactNode } from 'react';

import { Heading } from '@purpur/library';
import { Icon } from '@purpur/library/icon';

import { getSvgIcon } from '@telialt/common-icon/src';
import { VasProduct } from '@telialt/models/src/EshopModel';

import { IconContainer, IconText, ServicesContainer, ServicesList } from './RatePlanVas.styles';

type Props = {
    sectionTitle: string;
    vasList: VasProduct[];
    onClick?: (vasData: VasProduct) => void;
    vasLegalText?: ReactNode;
    'data-test'?: string;
};
export const PlanVas: FC<Props> = ({ sectionTitle, vasList, onClick, vasLegalText, 'data-test': dataTest }) => {
    const isClickable = Boolean(onClick);

    return (
        <ServicesContainer data-test={dataTest}>
            <Heading tag="h3" variant="title-100">
                {sectionTitle}
            </Heading>
            <ServicesList>
                {vasList.map((vasData, index) => {
                    const { iconType, title } = vasData;
                    const svgIcon = getSvgIcon(iconType);

                    return (
                        <IconContainer key={index} $isClickable={isClickable} onClick={() => onClick?.(vasData)}>
                            <Icon size="md" svg={svgIcon} ally-title={iconType} />
                            <IconText>{title}</IconText>
                        </IconContainer>
                    );
                })}
            </ServicesList>
            {vasLegalText}
        </ServicesContainer>
    );
};
